import * as React from 'react';
import { useState, useEffect } from 'react';
interface ModalProps {
    closeModal: Function,
    saveModal: Function,
    tenderTitle: string
}

const TenderModal = ({ closeModal, saveModal, tenderTitle }: ModalProps) => {
    const getTitle = () => {
        return `Répondre à l’offre ${tenderTitle}`;
    }

    return (
        <>
            <div
                className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
            >
                <div className="relative w-auto my-6 mx-auto max-w-3xl">
                    {/*content*/}
                    <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                        {/*header*/}
                        <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                            <h3 dangerouslySetInnerHTML={{ __html: getTitle() }} className="text-3xl font-semibold">

                            </h3>
                            <button
                                className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                                onClick={() => closeModal()}
                            >
                                <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                                    ×
                                </span>
                            </button>
                        </div>
                        {/*body*/}
                        <div className="relative p-6 flex-auto">
                            <textarea
                                id="tenderpost-textarea"
                                className="tender-modal"
                            >
                            </textarea>
                        </div>
                        {/*footer*/}
                        <div className="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
                            <button
                                className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                type="button"
                                onClick={() => closeModal()}
                            >
                                Fermer
                            </button>
                            <button
                                className="generic-button--dark-blue flex items-center justify-between gap-5"
                                type="button"
                                onClick={() => saveModal()}
                            >
                                Répondre
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
    );
}

export default TenderModal;

